import DOMPurify from 'dompurify';
import { transformCardLinks } from './cardLinkTransform';

/**
 * Article `contentHtml` is admin-authored TipTap output and is stored
 * unsanitized on both sides (Security audit 1219257699456713, item 15), so it is
 * sanitized here, at the only two render sites, after the [[Card Name]]
 * transform. The html profile keeps everything TipTap emits (headings, lists,
 * blockquote, pre/code, img, a, u, s, hr) plus the card-link placeholder span
 * with its data-card-name attribute, and drops script, event handlers,
 * javascript: URLs and iframes.
 */
const ARTICLE_SANITIZE_OPTIONS: DOMPurify.Config = {
  USE_PROFILES: { html: true },
  ADD_ATTR: ['target'],
};

export const sanitizeArticleHtml = (contentHtml: string): string =>
  DOMPurify.sanitize(transformCardLinks(contentHtml), ARTICLE_SANITIZE_OPTIONS);

export default sanitizeArticleHtml;
